import { render, staticRenderFns } from "./ChooseMarketplaceSubscriptionView.vue?vue&type=template&id=526912d0&"
import script from "./ChooseMarketplaceSubscriptionView.vue?vue&type=script&lang=ts&"
export * from "./ChooseMarketplaceSubscriptionView.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseMarketplaceSubscriptionView.vue?vue&type=style&index=0&id=526912d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports